import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const CreateSubscription = ({ onClose }) => {
  const [formData, setFormData] = useState({
    user_id: '',
    service_id: '',
    service_plan_id: '',
    start_date: '',
    order_id: '',
    payment_amount: '',
    payment_date: '',
  });
  const [users, setUsers] = useState([]);
  const [services, setServices] = useState([]);
  const [plans, setPlans] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, servicesRes, ordersRes] = await Promise.all([
          api.get('/api/users'),
          api.get('/api/services'),
          api.get('/api/orders'),
        ]);
        setUsers(usersRes.data);
        setServices(servicesRes.data);
        // Extraer todos los planes de los servicios
        const allPlans = servicesRes.data.flatMap(service => service.plans || []);
        setPlans(allPlans);
        setOrders(ordersRes.data.filter(order => order.status === 'pendiente' || order.status === 'pagado'));
      } catch (err) {
        setError('Error al cargar datos');
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newFormData = { ...prev, [name]: value };
      // Si se cambia el servicio, resetear el plan
      if (name === 'service_id') {
        newFormData.service_plan_id = '';
      }
      return newFormData;
    });
  };

  // Filtrar planes según el servicio seleccionado
  const filteredPlans = formData.service_id
    ? plans.filter(plan => plan.service_id === parseInt(formData.service_id))
    : plans;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/api/subscriptions', formData);
      onClose();
    } catch (err) {
      setError('Error al crear suscripción');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Crear Suscripción</h1>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="user_id">Usuario</label>
          <select
            name="user_id"
            value={formData.user_id}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          >
            <option value="">Selecciona un usuario</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>{`${user.first_name} ${user.last_name || ''}` || `ID ${user.id}`}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="service_id">Servicio</label>
          <select
            name="service_id"
            value={formData.service_id}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          >
            <option value="">Selecciona un servicio</option>
            {services.map((service) => (
              <option key={service.id} value={service.id}>{service.name || `ID ${service.id}`}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="service_plan_id">Plan</label>
          <select
            name="service_plan_id"
            value={formData.service_plan_id}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
            disabled={!formData.service_id}
          >
            <option value="">Selecciona un plan</option>
            {filteredPlans.map((plan) => (
              <option key={plan.id} value={plan.id}>{`${plan.name} - $${plan.price}` || `Plan ${plan.id}`}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="start_date">Fecha de Inicio</label>
          <input
            type="date"
            name="start_date"
            value={formData.start_date}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="order_id">Asociar Factura (Opcional)</label>
          <select
            name="order_id"
            value={formData.order_id}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          >
            <option value="">Crear nueva factura</option>
            {orders.map((order) => (
              <option key={order.id} value={order.id}>{`Factura ${order.id} - ${order.created_at} ($${order.total})`}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="payment_amount">Monto del Pago (Opcional)</label>
          <input
            type="number"
            name="payment_amount"
            value={formData.payment_amount}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            placeholder="Ej. 99.99"
            step="0.01"
          />
        </div>
        <div>
          <label className="block text-gray-700 mb-2" htmlFor="payment_date">Fecha del Pago (Opcional)</label>
          <input
            type="date"
            name="payment_date"
            value={formData.payment_date}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>
        <div className="flex justify-end space-x-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-700 disabled:bg-gray-400"
          >
            {loading ? 'Creando...' : 'Crear Suscripción'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateSubscription;